import { ANALYTICS_CARD_CREDIT_LIMIT_INCREASE_NOTIFICATION_VIEW } from '@perpay-web/fintech/constants/actionTypes';

export const analyticsPerpayCardCreditLimitIncreaseNotificationViewed = () => ({
    type: ANALYTICS_CARD_CREDIT_LIMIT_INCREASE_NOTIFICATION_VIEW,
});
